import { render, staticRenderFns } from "./ComposicaoItens.vue?vue&type=template&id=26cc289a&"
import script from "./ComposicaoItens.vue?vue&type=script&lang=js&"
export * from "./ComposicaoItens.vue?vue&type=script&lang=js&"
import style0 from "./ComposicaoItens.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports